/**
 * DirtyIndicatorAtom.tsx
 *
 * A small indicator badge showing that an item has unsaved changes.
 * Used in the factor sidebar to indicate dirty/modified state.
 */

import React from 'react';
import './DirtyIndicatorAtom.scss';

export type DirtyIndicatorVariant = 'badge' | 'dot';

export interface DirtyIndicatorAtomProps {
  /** Whether to show the indicator */
  show?: boolean;
  /** Visual variant */
  variant?: DirtyIndicatorVariant;
  /** Tooltip text */
  title?: string;
  /** Additional CSS class names */
  className?: string;
  /** Test ID for automation */
  'data-testid'?: string;
}

const DirtyIndicatorAtom: React.FC<DirtyIndicatorAtomProps> = ({
  show = true,
  variant = 'badge',
  title = 'Unsaved changes',
  className,
  'data-testid': testId,
}) => {
  if (!show) {
    return null;
  }

  const classes = [
    'dirty-indicator',
    `dirty-indicator--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (variant === 'dot') {
    return (
      <span className={classes} title={title} data-testid={testId}>
        <span className="dirty-indicator__dot" />
      </span>
    );
  }

  return (
    <span className={classes} title={title} data-testid={testId}>
      D
    </span>
  );
};

DirtyIndicatorAtom.displayName = 'DirtyIndicatorAtom';

export default DirtyIndicatorAtom;
